import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  Typography,
  CardContent,
  Tooltip,
  Button,
  Badge,
  Box,
  CardActions
} from '@material-ui/core';

import MicIcon from '@material-ui/icons/Mic';
import { getTimestamp } from '../../utils';
import { GermanFlagIcon, UKFlagIcon, USFlagIcon } from '../Icons';
import useStyles from './styles.js';

const TranscriptCard = ({
  id,
  name,
  length,
  countSpeaker,
  language,
  handleDelete,
  transcriptStatus,
  openTranscript
}) => {
  const classes = useStyles();
  const isProcessing = transcriptStatus === 'PROCESSING';

  const openTranscriptProject = e => {
    e.preventDefault();
    if (!isProcessing) {
      // TODO:
      openTranscript();
    }
  };

  const getFlagIcon = language => {
    switch (language) {
      case 'de-DE':
        return <GermanFlagIcon className={classes.icon} />;
      case 'en-US':
        return <USFlagIcon className={classes.icon} />;
      case 'en-GB':
        return <UKFlagIcon className={classes.icon} />;
      default:
        return;
    }
  };

  const languageName = language => {
    switch (language) {
      case 'de-DE':
        return 'german';
      case 'en-US':
      case 'en-GB':
        return 'english';
      default:
        return 'unkown';
    }
  };

  return (
    <Card className={classes.card}>
      <CardContent>
        <Typography className={classes.title} variant="h6" component="h2">
          {name}
        </Typography>
        <Typography color="textSecondary">
          {getTimestamp(length, false)}
        </Typography>
      </CardContent>

      <CardActions className={classes.cardActions}>
        <Box className={classes.actionButtons}>
          {isProcessing ? (
            <Button
              size="medium"
              color="primary"
              aria-label="processing"
              disabled={true}
            >
              Processing
            </Button>
          ) : (
            <Tooltip title="Open Transcript">
              <Button
                size="medium"
                color="primary"
                aria-label="open"
                onClick={openTranscriptProject}
              >
                Open
              </Button>
            </Tooltip>
          )}
          <Tooltip title={`Delete Transcript`}>
            <Button
              size="small"
              color="default"
              aria-label="delete"
              onClick={handleDelete}
            >
              Delete
            </Button>
          </Tooltip>
        </Box>
        <Box className={classes.icons}>
          <Tooltip title={`This Transcript is in ${languageName(language)}`}>
            <span>{getFlagIcon(language)}</span>
          </Tooltip>
          <Tooltip
            title={`This Transcript has ${countSpeaker} speaker${countSpeaker >
              1 && 's'}`}
          >
            <Badge
              className={classes.icon}
              badgeContent={countSpeaker}
              color="primary"
            >
              <MicIcon />
            </Badge>
          </Tooltip>
        </Box>
      </CardActions>
    </Card>
  );
};
TranscriptCard.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  length: PropTypes.number,
  countSpeaker: PropTypes.number,
  language: PropTypes.string,
  handleDelete: PropTypes.func,
  status: PropTypes.oneOf(['TRANSCRIPTION_PENDING', 'DONE'])
};

export default TranscriptCard;
